// What the alert form holds so far, as the sentence the Orpheus setup panel starts from (v3
// `AlertModal.vue`'s `describeForOrpheus`), so switching over loses nothing the user already filled
// in. Read by the model as the setup's first message, so it is plain sentences over the form's own
// review rows; an empty form hands over nothing and the panel opens on its own suggestions.
import type { AlertSummarySection } from '../composables/useAlertSummary'
import type { AlertMetricCondition } from '../models/alert.types'
import type { AlertReportFilter } from '../models/reports-bridge'

function filterText(filter: AlertReportFilter): string {
  const value = Array.isArray(filter.value) ? filter.value.join(', ') : filter.value
  return [filter.field, filter.match_mode, value]
    .filter((part) => part !== null && part !== undefined && part !== '')
    .map((part) => String(part))
    .join(' ')
}

function conditionText(condition: AlertMetricCondition): string {
  const amount =
    condition.amount === null
      ? ''
      : `${condition.amount}${condition.mode === 'percentage' ? '%' : ''}`
  const compare =
    condition.mode === 'percentage' && condition.compareWindow
      ? `vs ${condition.compareWindow}`
      : ''
  return [condition.column.header, condition.operator, amount, compare].filter(Boolean).join(' ')
}

function sectionText(section: AlertSummarySection): string {
  switch (section.kind) {
    case 'text':
      return section.value ?? ''
    case 'chips':
      return section.values.join(', ')
    case 'filters':
      return section.values.map(filterText).filter(Boolean).join(', ')
    case 'conditions':
      return section.values.map(conditionText).filter(Boolean).join('; ')
  }
}

export function alertOrpheusBrief(sections: readonly AlertSummarySection[]): string {
  const filled = sections
    .map((section) => [section.label, sectionText(section)] as const)
    .filter(([, text]) => text)
    .map(([label, text]) => `${label}: ${text}`)
  return filled.length ? `Set up this alert. ${filled.join('. ')}.` : ''
}
